import { PageTabContent } from '../../cohort-builder-page-layout/StyledPageTabContent/PageTabContent';
import { CohortDefinitionTranslationSection } from '../../cohort-builder-sections/CohortDefinitionTranslationSection/CohortDefinitionTranslationSection';
import { CriteriaSection } from '../../cohort-builder-sections/CriteriaSection/CriteriaSection';
import { IndexDateSection } from '../../cohort-builder-sections/IndexDateSection/IndexDateSection';
import { StudyPeriodSection } from '../../cohort-builder-sections/StudyPeriodSection/StudyPeriodSection';

export const DefinitionPageTabContent = () => {
  return (
    <PageTabContent>
      <IndexDateSection />
      <StudyPeriodSection />
      <CriteriaSection />
      <CohortDefinitionTranslationSection />
    </PageTabContent>
  );
};
